import { Event, EventForm } from "@/models/agenda.model";

export class AgendaMapper {
  formatTime(date: Date, time: string): string {
    const [hour, min, seconds] = time.split(":");
    date.setHours(Number(hour), Number(min), Number(seconds));
    return date.toJSON();
  }

  formatDateToString(date: Date): string {
    if (!date) return "";
    const newDate = new Date(date);
    const offset = newDate.getTimezoneOffset();
    const localDate = new Date(newDate.getTime() - offset * 60 * 1000);
    const [year, month, day] = localDate.toISOString().slice(0, 10).split("-");
    const hour = localDate.toISOString().slice(11, 16);
    return `${year}-${month}-${day} ${hour}`;
  }

  formatStringToDate(date: any, time: string): string {
    const [hour, min, seconds] = time.split(":");
    date.setHours(Number(hour), Number(min), Number(seconds));

    return new Date(date).toISOString();
  }
  toDomain(persistenceData: any): Event {
    return {
      id: persistenceData.id!,
      title: persistenceData.name!,
      start: this.formatDateToString(persistenceData.start_date)!,
      end: this.formatDateToString(persistenceData.end_date)!,
      url: persistenceData.external
        ? persistenceData.url
        : `${process.env.VUE_APP_URL_TALKROOM}${persistenceData.url!}`,
      calendarId: "group",
      owner: persistenceData.owner?.name!,
      ownerId: persistenceData.owner_id,
      isPublic: persistenceData.is_public,
      record: persistenceData.record,
      hash: persistenceData.hash_room,
      videos: persistenceData.videos,
    };
  }

  eventToPersistence(event: EventForm) {
    if (!event.date) return;
    return {
      id: event.id,
      name: event.name,
      classroomId: event.classroom,
      courseId: event.course,
      record: event.record,
      isPublic: event.isPublic,
      startDate: this.formatTime(
        event.date,
        this.addSecondsTime(event.startTime)
      ),
      endDate: this.formatTime(event.date, this.addSecondsTime(event.endTime)),
      url: event.url.trim().length > 0 ? event.url : undefined,
    };
  }

  addSecondsTime(value: string): string {
    return value.concat(":00");
  }
}
